import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Share2, ChevronDown } from 'lucide-react';
import { MetaTags } from '../../../../components/SEO/MetaTags';
import { RelatedBlogPosts } from '../../../../components/Blog/RelatedBlogPosts';
export function BlogPostCovertNarcissistID() {
  const articleData = {
    title: 'Apakah Mantan Anda Narsisis Terselubung? (Teks Tidak Berbohong)',
    description: 'Bertanya-tanya apakah mantan Anda adalah narsisis terselubung? Temukan 7 perilaku manipulatif halus yang dideteksi AI kami secara instan dalam pesan teks.',
    slug: 'is-your-ex-a-covert-narcissist',
    publishDate: '2025-03-08',
    author: 'Editorial Toxic Detector'
  };
  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [{
      '@type': 'Question',
      name: 'Apa itu narsisis terselubung dan bagaimana bedanya dengan narsisis terbuka?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Narsisis terselubung menyembunyikan perilaku manipulatif mereka di balik pesona, taktik emosional halus, dan pesan pasif-agresif, tidak seperti narsisis yang jelas dan terbuka.'
      }
    }, {
      '@type': 'Question',
      name: 'Bisakah AI mendeteksi narsisme terselubung dalam pesan teks?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Ya. Toxic Detector menganalisis nada, rasa bersalah, siklus love-bombing, inkonsistensi, dan pola manipulasi emosional untuk menandai perilaku narsisis terselubung.'
      }
    }, {
      '@type': 'Question',
      name: 'Apa perilaku umum narsisis terselubung dalam teks?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Manipulasi emosional, gaslighting, komentar pasif-agresif, bermain korban, love-bombing diikuti penarikan diri, dan kontrol halus.'
      }
    }, {
      '@type': 'Question',
      name: 'Bagaimana saya bisa melindungi diri dari narsisis terselubung?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Dokumentasikan pesan, percayai insting Anda, pertahankan batasan, dan gunakan alat seperti Toxic Detector untuk mengidentifikasi pola manipulatif secara objektif.'
      }
    }]
  };
  const articleSchema = {
    '@context': 'https://schema.org',
    '@type': 'BlogPosting',
    headline: articleData.title,
    description: articleData.description,
    image: 'https://toxicdetector.com/images/logo.png',
    author: {
      '@type': 'Person',
      name: articleData.author
    },
    publisher: {
      '@type': 'Organization',
      name: 'ToxicDetector',
      logo: {
        '@type': 'ImageObject',
        url: 'https://toxicdetector.com/images/logo.png'
      }
    },
    datePublished: articleData.publishDate,
    dateModified: articleData.publishDate,
    url: `https://toxicdetector.com/id/blog/${articleData.slug}`
  };
  const handleShare = async () => {
    try {
      await navigator.share({
        title: articleData.title,
        text: articleData.description,
        url: 'https://toxicdetector.com/'
      });
    } catch (err) {
      navigator.clipboard.writeText(window.location.href);
      alert('Tautan disalin ke papan klip!');
    }
  };
  return <>
      <MetaTags title="Apakah Mantan Anda Narsisis Terselubung? Bagaimana AI Mendeteksi Manipulasi | ToxicDetector" description="Bertanya-tanya apakah mantan Anda adalah narsisis terselubung? Temukan 7 perilaku manipulatif halus yang dideteksi AI kami secara instan." keywords="tanda narsisis terselubung, perilaku narsisis tersembunyi, manipulasi narsisis teks, detektor narsisis AI" canonical={`https://toxicdetector.com/id/blog/${articleData.slug}`} ogType="article" ogImage="https://cdn.magicpatterns.com/uploads/eYBGg4SniMpbkGoP3a2Uyt/file_00000000bb6072439a9d5e3820051ce3.png" schema={[faqSchema, articleSchema]} data-id="element-6880" />
      <div className="flex flex-col w-full min-h-screen bg-gradient-to-b from-stone-50 to-white" data-id="element-6881">
        <header className="bg-white/90 border-b border-gray-200 sticky top-0 z-50 backdrop-blur-sm" data-id="element-6882">
          <div className="max-w-3xl mx-auto px-6 py-4" data-id="element-6883">
            <div className="flex items-center justify-between" data-id="element-6884">
              <Link to="/" className="text-2xl font-bold tracking-tight text-gray-900" data-id="element-6885">
                🚩 ToxicDetector
              </Link>
              <button onClick={handleShare} className="p-2.5 hover:bg-gray-50 rounded-lg transition-colors" aria-label="Bagikan artikel" data-id="element-6886">
                <Share2 size={20} className="text-gray-600" data-id="element-6887" />
              </button>
            </div>
          </div>
        </header>

        <article className="max-w-3xl mx-auto w-full px-6 py-12" data-id="element-6888">
          <Link to="/blog" className="inline-flex items-center text-gray-600 text-sm mb-10 hover:text-gray-900 transition-colors group" data-id="element-6889">
            <ArrowLeft size={16} className="mr-2 group-hover:-translate-x-1 transition-transform" data-id="element-6890" />
            Kembali ke Blog
          </Link>

          <header className="mb-12" data-id="element-6891">
            <h1 className="text-4xl md:text-5xl font-bold mb-6 tracking-tight leading-tight text-gray-900" data-id="element-6892">
              {articleData.title}
            </h1>
            <div className="flex items-center text-gray-600 text-sm gap-3" data-id="element-6893">
              <time dateTime={articleData.publishDate} data-id="element-6894">
                {new Date(articleData.publishDate).toLocaleDateString('id-ID', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
              })}
              </time>
              <span className="text-gray-300" data-id="element-6895">•</span>
              <span data-id="element-6896">{articleData.author}</span>
            </div>
          </header>

          <div className="mb-12" data-id="element-6897">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/eAKNBAYBhED67QeywsaDY6/1763120946474.jpg" alt="Wanita menganalisis pesan teks untuk tanda-tanda manipulasi narsisis terselubung dengan AI" className="w-full rounded-2xl shadow-sm border border-gray-200" data-id="element-6898" />
          </div>

          <div className="bg-white rounded-xl p-6 border border-gray-200 mb-12" data-id="element-6899">
            <h2 className="font-bold text-lg mb-4 text-gray-900" data-id="element-6900">Daftar Isi</h2>
            <ul className="space-y-3 text-sm" data-id="element-6901">
              <li data-id="element-6902">
                <a href="#emotional-manipulation" className="text-gray-600 hover:text-gray-900 transition-colors flex items-center gap-2" data-id="element-6903">
                  <span className="text-gray-400" data-id="element-6904">→</span> 1. Manipulasi
                  Emosional di Setiap Pesan
                </a>
              </li>
              <li data-id="element-6905">
                <a href="#gaslighting" className="text-gray-600 hover:text-gray-900 transition-colors flex items-center gap-2" data-id="element-6906">
                  <span className="text-gray-400" data-id="element-6907">→</span> 2. Gaslighting yang
                  Terbangun Perlahan
                </a>
              </li>
              <li data-id="element-6908">
                <a href="#passive-aggressive" className="text-gray-600 hover:text-gray-900 transition-colors flex items-center gap-2" data-id="element-6909">
                  <span className="text-gray-400" data-id="element-6910">→</span> 3. Komentar
                  Pasif-Agresif
                </a>
              </li>
              <li data-id="element-6911">
                <a href="#playing-victim" className="text-gray-600 hover:text-gray-900 transition-colors flex items-center gap-2" data-id="element-6912">
                  <span className="text-gray-400" data-id="element-6913">→</span> 4. Selalu Bermain
                  Korban
                </a>
              </li>
              <li data-id="element-6914">
                <a href="#love-bombing" className="text-gray-600 hover:text-gray-900 transition-colors flex items-center gap-2" data-id="element-6915">
                  <span className="text-gray-400" data-id="element-6916">→</span> 5. Love-Bombing Lalu
                  Penarikan
                </a>
              </li>
              <li data-id="element-6917">
                <a href="#hidden-control" className="text-gray-600 hover:text-gray-900 transition-colors flex items-center gap-2" data-id="element-6918">
                  <span className="text-gray-400" data-id="element-6919">→</span> 6. Kontrol &
                  Pemantauan Tersembunyi
                </a>
              </li>
              <li data-id="element-6920">
                <a href="#inconsistent-tone" className="text-gray-600 hover:text-gray-900 transition-colors flex items-center gap-2" data-id="element-6921">
                  <span className="text-gray-400" data-id="element-6922">→</span> 7. Nada Tidak
                  Konsisten Antar Saluran
                </a>
              </li>
            </ul>
          </div>

          <div className="prose prose-lg max-w-none" data-id="element-6923">
            <p className="text-xl mb-8 leading-relaxed text-gray-700" data-id="element-6924">
              Pernah merasa mantan Anda memanipulasi Anda di balik layar, sambil
              terlihat menawan dan peduli? Itu adalah{' '}
              <strong data-id="element-6925">tanda klasik narsisis terselubung</strong>. Tidak seperti
              narsisis yang jelas, yang terselubung menyembunyikan manipulasi
              mereka di balik taktik emosional yang halus.
            </p>
            <p className="mb-12 text-lg leading-relaxed text-gray-600" data-id="element-6926">
              AI kami <strong data-id="element-6927">mendeteksi manipulasi tersembunyi</strong> secara
              instan hanya dengan menganalisis teks mereka. Begini caranya.
            </p>

            <section id="emotional-manipulation" className="mb-12" data-id="element-6928">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-6929">
                1️⃣ Manipulasi Emosional di Setiap Pesan
              </h2>
              <p className="mb-6 text-lg leading-relaxed text-gray-600" data-id="element-6930">
                Narsisis terselubung memutarbalikkan emosi untuk mendapatkan
                keinginan mereka.
              </p>
              <div className="bg-gray-50 border-l-4 border-purple-600 p-6 mb-6 rounded-r-xl" data-id="element-6931">
                <p className="italic text-gray-700 text-lg" data-id="element-6932">
                  "Aku tidak percaya kamu marah karena ini..."
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-6933">
                AI mendeteksi rasa bersalah halus dan tekanan emosional yang
                tersembunyi dalam pesan sehari-hari.
              </p>
            </section>

            <section id="gaslighting" className="mb-12" data-id="element-6934">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-6935">
                2️⃣ Gaslighting yang Terbangun Perlahan
              </h2>
              <div className="bg-gray-50 border-l-4 border-purple-600 p-6 mb-6 rounded-r-xl" data-id="element-6936">
                <p className="italic text-gray-700 text-lg" data-id="element-6937">
                  "Kamu salah mengingatnya..."
                </p>
              </div>
              <p className="mb-6 text-lg leading-relaxed text-gray-600" data-id="element-6938">
                Narsisis terselubung membuat Anda meragukan ingatan Anda
                sendiri. AI menandai kejadian berulang di mana kenyataan
                diputarbalikkan.
              </p>
            </section>

            <section id="passive-aggressive" className="mb-12" data-id="element-6939">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-6940">
                3️⃣ Komentar Pasif-Agresif
              </h2>
              <div className="bg-gray-50 border-l-4 border-purple-600 p-6 mb-6 rounded-r-xl" data-id="element-6941">
                <p className="italic text-gray-700 text-lg" data-id="element-6942">
                  "Tentu, apa pun yang membuatmu bahagia..."
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-6943">
                Agresi pasif adalah ciri khas narsisme terselubung. AI mengenali
                sarkasme, sindiran, dan permusuhan terselubung.
              </p>
            </section>

            <section id="playing-victim" className="mb-12" data-id="element-6944">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-6945">
                4️⃣ Selalu Bermain Korban
              </h2>
              <div className="bg-gray-50 border-l-4 border-purple-600 p-6 mb-6 rounded-r-xl" data-id="element-6946">
                <p className="italic text-gray-700 text-lg" data-id="element-6947">
                  "Setelah semua yang aku lakukan untukmu..."
                </p>
              </div>
              <p className="mb-6 text-lg leading-relaxed text-gray-600" data-id="element-6948">
                Narsisis terselubung sering membalikkan kesalahan, menjadikan
                diri mereka korban. AI mendeteksi frasa yang dirancang untuk
                membuat Anda merasa bersalah.
              </p>
            </section>

            <section id="love-bombing" className="mb-12" data-id="element-6949">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-6950">
                5️⃣ Love-Bombing Lalu Penarikan
              </h2>
              <div className="bg-gray-50 border-l-4 border-purple-600 p-6 mb-6 rounded-r-xl" data-id="element-6951">
                <p className="italic text-gray-700 text-lg" data-id="element-6952">
                  "Kamu satu-satunya yang pernah aku cintai 😢" → ghosting
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-6953">
                Siklus klasik kasih sayang intens diikuti jarak emosional ini
                adalah tanda bahaya. AI mengidentifikasi pola ini di berbagai
                obrolan.
              </p>
            </section>

            <section id="hidden-control" className="mb-12" data-id="element-6954">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-6955">
                6️⃣ Kontrol & Pemantauan Tersembunyi
              </h2>
              <div className="bg-gray-50 border-l-4 border-purple-600 p-6 mb-6 rounded-r-xl" data-id="element-6956">
                <p className="italic text-gray-700 text-lg" data-id="element-6957">
                  "Hanya memeriksa... lagi"
                </p>
              </div>
              <p className="mb-6 text-lg leading-relaxed text-gray-600" data-id="element-6958">
                Kontrol halus yang disamarkan sebagai kepedulian adalah taktik
                terselubung. AI menandai perilaku pemeriksaan berulang tanpa
                agresi terbuka.
              </p>
            </section>

            <section id="inconsistent-tone" className="mb-12" data-id="element-6959">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-6960">
                7️⃣ Nada Tidak Konsisten Antar Saluran
              </h2>
              <div className="bg-gray-50 border-l-4 border-purple-600 p-6 mb-6 rounded-r-xl" data-id="element-6961">
                <p className="italic text-gray-700 text-lg" data-id="element-6962">
                  Grup chat: main-main / 1:1: kritis
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-6963">
                Narsisis terselubung sering menyembunyikan perilaku mereka di
                depan umum sambil memanipulasi secara pribadi. AI membandingkan
                percakapan untuk menyoroti perbedaan.
              </p>
            </section>

            <section className="mb-12" data-id="element-6964">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-6965">
                🛡 Cara Melindungi Diri Sendiri
              </h2>
              <div className="bg-white rounded-xl border border-gray-200 p-6" data-id="element-6966">
                <ul className="space-y-3 text-lg text-gray-600" data-id="element-6967">
                  <li className="flex items-start gap-3" data-id="element-6968">
                    <span className="text-purple-600 font-bold" data-id="element-6969">•</span>
                    <span data-id="element-6970">
                      Percayai insting Anda. Jangan abaikan tanda bahaya.
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-6971">
                    <span className="text-purple-600 font-bold" data-id="element-6972">•</span>
                    <span data-id="element-6973">Simpan tangkapan layar untuk kejelasan.</span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-6974">
                    <span className="text-purple-600 font-bold" data-id="element-6975">•</span>
                    <span data-id="element-6976">
                      Bagikan pengalaman Anda dengan teman atau terapis.
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-6977">
                    <span className="text-purple-600 font-bold" data-id="element-6978">•</span>
                    <span data-id="element-6979">
                      Gunakan alat seperti Toxic Detector untuk mengidentifikasi
                      pola.
                    </span>
                  </li>
                </ul>
              </div>
            </section>

            <section className="mb-12" data-id="element-6980">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-6981">
                💀 Lihat Dengan Mata Kepala Sendiri
              </h2>
              <p className="mb-6 text-lg leading-relaxed text-gray-600" data-id="element-6982">
                Narsisme terselubung bisa sulit dikenali, tetapi AI tidak
                melewatkan apa pun. Unggah obrolan Anda dan dapatkan analisis
                instan:
              </p>
              <div className="bg-white border border-gray-200 rounded-xl p-6 mb-6" data-id="element-6983">
                <p className="text-gray-900 font-bold text-center text-lg" data-id="element-6984">
                  "🚩 78% manipulasi terdeteksi. Taktik terselubung
                  diidentifikasi!"
                </p>
              </div>
            </section>

            <section id="faq" className="mb-12" data-id="element-6985">
              <h2 className="text-3xl font-bold mb-8 tracking-tight text-gray-900" data-id="element-6986">
                Pertanyaan yang Sering Diajukan
              </h2>
              <div className="space-y-4" data-id="element-6987">
                {faqSchema.mainEntity.map((faq, index) => <details key={index} className="bg-white rounded-xl border border-gray-200 overflow-hidden group" data-id="element-6988">
                    <summary className="px-6 py-4 cursor-pointer font-semibold text-base text-gray-900 hover:bg-gray-50 transition-colors flex items-center justify-between" data-id="element-6989">
                      <span data-id="element-6990">{faq.name}</span>
                      <ChevronDown size={20} className="text-gray-400 group-open:rotate-180 transition-transform" data-id="element-6991" />
                    </summary>
                    <div className="px-6 pb-4 text-gray-600 leading-relaxed text-sm" data-id="element-6992">
                      {faq.acceptedAnswer.text}
                    </div>
                  </details>)}
              </div>
            </section>
          </div>

          <div className="bg-purple-600 rounded-2xl p-10 text-center text-white mt-16" data-id="element-6993">
            <h2 className="text-3xl font-bold mb-4 tracking-tight" data-id="element-6994">
              💀 Siap Mengungkap Kebenaran?
            </h2>
            <p className="text-purple-100 mb-8 text-lg leading-relaxed max-w-2xl mx-auto" data-id="element-6995">
              Berhenti menebak. Unggah teks Anda ke Toxic Detector dan dapatkan
              skor toksisitas instan. AI kami mengungkapkan manipulasi
              terselubung yang mungkin Anda lewatkan.
            </p>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 mb-8 border border-white/20" data-id="element-6996">
              <p className="font-bold text-xl" data-id="element-6997">
                "🚩 78% manipulasi terdeteksi. Taktik terselubung
                diidentifikasi!"
              </p>
            </div>
            <Link to="/signup" className="inline-block bg-white text-purple-600 px-10 py-4 rounded-lg font-bold text-lg hover:bg-gray-50 transition-colors" data-id="element-6998">
              Pindai Obrolan Anda Sekarang →
            </Link>
          </div>

          <RelatedBlogPosts posts={[{
          title: '7 Tanda Gaslighting yang Terdeteksi AI Kami Secara Instan',
          description: 'Pelajari pola gaslighting utama yang dideteksi AI dalam percakapan teks Anda.',
          slug: '7-signs-of-gaslighting',
          emoji: '💀'
        }, {
          title: 'Panduan Utama Teks Pasif-Agresif',
          description: 'Temukan perilaku pasif-agresif dan manipulasi tersembunyi dalam pesan teks.',
          slug: 'passive-aggressive-texts-guide',
          emoji: '😤'
        }]} data-id="element-6999" />

          <div className="mt-12 text-center" data-id="element-7000">
            <button onClick={handleShare} className="inline-flex items-center text-gray-600 hover:text-gray-900 font-medium transition-colors text-sm" data-id="element-7001">
              <Share2 size={18} className="mr-2" data-id="element-7002" />
              Bagikan artikel ini
            </button>
          </div>
        </article>

        <footer className="bg-white border-t border-gray-200 py-12 mt-16" data-id="element-7003">
          <div className="max-w-3xl mx-auto px-6 text-center" data-id="element-7004">
            <p className="text-gray-500 text-sm" data-id="element-7005">
              © {new Date().getFullYear()} ToxicDetector. Hak cipta dilindungi
              undang-undang.
            </p>
          </div>
        </footer>
      </div>
    </>;
}